
import { Component, Vue } from 'vue-property-decorator'
import eventBus from '@/plugins/eventBus'
@Component({})
export default class switcher extends Vue {
  switchTo(tabName: any) {
    eventBus.$emit('switch:tabs', tabName)
  }
}
